export const chartdata=[
  {
    "id": 1,
    "title": "Vulnerabilities",
    "price": "68",
    "perstangeValue": "97.14",
    "badgeColor": "danger",
    "seriesData": [
      {
        "name": "Vulnerabilities",
        "data": [
          36,
          21,
          65,
          22,
          35,
          68
        ]
      }
    ],
    "color": [
      "--bs-danger",
      "--bs-transparent"
    ]
  },
  {
    "id": 2,
    "title": "Resolved",
    "price": "2",
    "perstangeValue": "2.94",
    "badgeColor": "success",
    "seriesData": [
      {
        "name": "Resolved",
        "data": [
          36,
          48,
          10,
          74,
          35,
          2
        ]
      }
    ],
    "color": [
      "--bs-success",
      "--bs-transparent"
    ]
  },
  {
    "id": 3,
    "title": "Unresolved",
    "price": "3",
    "perstangeValue": "4.41",
    "badgeColor": "warning",
    "seriesData": [
      {
        "name": "Unresolved",
        "data": [
          60,
          14,
          5,
          60,
          30,
          3
        ]
      }
    ],
    "color": [
      "--bs-warning",
      "--bs-transparent"
    ]
  },
  {
    "id": 4,
    "title": "Risk Score",
    "price": "4",
    "perstangeValue": "4.00",
    "badgeColor": "danger",
    "istrendingArrow": true,
    "seriesData": [
      {
        "name": "Risk Score",
        "data": [
          32,
          22,
          7,
          55,
          20,
          4
        ]
      }
    ],
    "color": [
      "--bs-danger",
      "--bs-transparent"
    ]
  }
];
      